   export class RequestServiceModelView {
    id: number;
    lotNumber: number;
    wrTypeCD: string;
    applicantContactName1: string;
    applicantContactName2: string;
    applicantEmail: string;
    applicantPhoneNumber: string;
    applicantPhoneExtension: string;
    applicantStreetNo: number;
    applicantStreetName: string;
    applicantStreetType: string;
    applicantDirectionPrefix: string;
    applicantUnitNo: string;
    applicantDirectionSuffix: string;
    applicantAddress2: string;
    applicantCity: string;
    applicantState: string;
    applicantZip: string;
    deliveryPressure: string;
    developmentName: string;
    heatedSquareFootage: number;
     serviceNeededBy: Date;
     plannedDt: Date;
    installedDTTM: Date;
    lotStatus: string;
    countyId: string;
    builderId: string;
    stateCd: string;
    address: string;
    grId: number;
    streetNo: number;
    streetName: string;
    city: string;
    zip: string;
     wrSummaryId: number;
     wrStatus: string;
    subDivision: string;
    unitNo: string;
    originalBd: string;
    checked: boolean;
    originalCName: string;
    builderCName: string;
  otherDeliveryPressure: string;
  plumberCompanyName: string;
  plumberContactName: string;
  plumberContactNo: string;
  statusDesc: string;
  requestType: string;
  constructionSiteStatus: string;
  typicalInstallationTimeFrame: string;
  requestInstallationOrder: string;
  closingDate: Date;
  siteStatusUpdateDate: Date;
  nextSiteStatusDueDate: Date;
  buildingPointId: string;
  lookerStatus: string;
  estimatedInstallDateOfService: Date;
  actualInstallDateOfService: Date;
  estimatedInstallDateOfMeter: Date;
  actualInstallDateOfMeter: Date;
  locate: string;
  recCreateDttm: string;
  recCreateUsrId: string;
  recUpdateDttm: string;
  recUpdateUsrId: string;
  isManualLotRequested: string;
  lotStatusUpdatedBy: string;
  lotStatusUpdatedDate: string;
  constructionCompleteDate: Date;
  meterNumber: number;
   }
